<template>
  <div id="admin">
    <menu-admin/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center"><i class="fa fa-users"></i>  Usuários</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="input-group" style="margin-bottom: 10px">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-search"></i></span>
            </div>
            <input type="text" class="form-control" id="myInput" @keyup.enter="getUsers(1)" v-model="search" placeholder="Filtrar usuários..." />
            <div class="input-group-append">
              <span class="input-group-text" @click="getUsers(1)"><i class="fa fa-refresh"></i></span>
            </div>
          </div>

          <table class="table table-bordered table-bordered" style="background: white">
            <thead>
            <tr>
              <th width="20">ID</th>
              <th>Usuário</th>
              <th>E-mail</th>
              <th width="150">Telefone</th>
              <th width="20">Cert</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in users" v-bind:key="user.id">
              <td>{{user.id}}</td>
              <td>
                <a href="javascript:;" @click="redirectURL('/admin/user/'+user.id)">
                  <span v-if="user.person_or_company">{{user.company_name}}</span>
                  <span v-else>{{user.name}}</span>
                </a>
              </td>
              <td>{{user.user.email}}</td>
              <td>{{user.phone}}</td>
              <td class="text-center"><a @click="downloadCert(user.user.email)"><i class="fa fa-certificate"></i></a></td>
            </tr>
            <tr v-show="!users.length"><td colspan="5" class="text-center">Nenhum resultado pode ser encontrado</td></tr>
            </tbody>
          </table>
          <div class="pagination pagination-medium pagination-right">
            <div class="pull-left">
              Pagina {{current}} de {{pages}}
            </div>
            <ul>
              <li id="previous"><a href="javascript:;" @click="getUsers(previous)">Anterior</a></li>
              <li id="next"><a href="javascript:;" @click="getUsers(next)">Próxima</a></li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <footer-admin/>
  </div>
</template>

<script>
  import user from "../../api/user"
  import menuAdmin from "../admin/common/menu-admin"
  import footerAdmin from "../admin/common/footer-admin"
  import { mapState } from 'vuex'
  import mixins from "../../helpers/mixins"
  import signature from '../../api/signature'
  export default {
    name: "AdminUsers",
    mixins: [mixins],
    data () {
      return {
        users: [],
        page: 1,
      }
    },
    components: { menuAdmin, footerAdmin },
    computed: {
      ...mapState(['logged'])
    },
    methods: {
      getUsers(page){
        this.page = page
        user.list(this.page, this.search).then((response)  =>  {
          this.users = response.data.results
          this.treatPagination(page, response.data.count, response.data.pages)
        })
      },
      downloadCert(email){
        signature.getCertificate({email: email}).then(response => {
          let blob = new Blob([response.data], { type:   'application/pdf' } )
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'Certificate_'+email+'.pdf'
          link.click()
        })
      }
    },
    activated(){
      this.getUsers(this.page)
    },
    mounted(){
      this.getUsers(this.page)
    }
  }
</script>

<style scoped>
  .jumbotron-fluid{
    padding-top: 100px;
    padding-bottom: 20px;
    margin-bottom: 10px;
  }
</style>
